import { useQuery } from "@tanstack/react-query";

import useUser from "../useUser";
import API from "../../../api/API";
import { Session } from "../../../../types/GlobalInterfaces";

const useSessions = (queryPagination: {
  Pagination: { Count: number; Page: number };
}) => {
  const { user } = useUser();

  const { Pagination } = queryPagination;

  const sessions = useQuery({
    queryKey: ["sessions", Pagination],
    queryFn: () =>
      API.getSessions(Pagination.Count, Pagination.Page).then(
        (data) => data.data.data
      ),
    enabled: !!user?.id,
  });

  return {
    sessions: (sessions.data?.data ?? []) as Session[],
    pagination: sessions.data?.pagination ?? {},
    sessionsLoading: sessions.isLoading || !!user?.id === false,
  };
};

export default useSessions;
